import React, { PureComponent } from 'react';
import { IonPage, isPlatform } from '@ionic/react';
import { setScreenName } from "../../utils/Analytics"
import { RegisterForm, REGISTER_ERROR_MESSAGE, carrierUsDotNo, REGISTER_PLACEHOLDER, USER_FORM_ERRORS, CountryCodesForUser } from '../../utils/constants';
import './Registration.page.scss';
import {
  getSelectedRoles,
  registrationroles,
  handlePhoneNumber,
  normalizeInput
} from '../Manage/ManageUser/ManageUserUtil';
import NetworkErrorToaster from '../../components/NetworkErrorToaster/NetworkErrorToaster';
import { logEvent } from '../../utils/Analytics';
import { EVENT, SCREEN } from '../../utils/constants.analytics';
import { RegistrationFormMobile } from './RegistraionFormMobile';
import { RegistrationFormDesktop } from './RegistrationFormDesktop';
import { isEqual } from 'lodash';
import { IONICWrapper, validatePhoneNumberFormat } from '../../utils/common';
import { validateMobileNumberSchema } from '../../schemas/App/MobileNumberValidate.Schema';
import { validateMobileNumber } from '../../actions/App/action';

const textpattern = /^[a-zA-Z0-9 ]*$/;
const numericPattern = /^[0-9]*$/;

class RegisterComponent extends PureComponent<any, any> {
  state = {
    showOptions: false,
    slectedNo: 'carrierMcNo',
    firstName: '',
    lastName: '',
    mobileNumber: '',
    companyName: '',
    corporateZipCode: '',
    tractorNumber: '',
    addressDTOs: null,
    role: registrationroles,
    allowToSave: false,
    roleError: '',
    usDotError: null,
    mobileNumberError: '',
    zipcodeEror: '',
    firstNameError: '',
    lastNameError: '',
    companyNameError: '',
    tractorNumberError: '',
    USDOTNO: '',
    placeHolderText: REGISTER_PLACEHOLDER.mc,
    mobileReadOnly: false,
    isDriverSelected: false,
    isRoleSelected: false,
    mobileValError: 0,
    countryCode:"+1",
    editMobileNumber:true,
    payloadCountryCode:"",
    dropDownValues : IONICWrapper?.details?.keys?.configuration?.CountryCodes || CountryCodesForUser
  };

  componentDidMount() {
    setScreenName("screen_registration")

    logEvent(EVENT.SV_REGISTRATION, {
      screen: SCREEN.REGISTRATION
    });
  }
  componentDidUpdate(prevProps: any) {
    // Regarding Defect DE15972
    if (!isEqual(prevProps.phoneNumber, this.props.phoneNumber)) {
      const phone = (this.props.phoneNumber && this.props.phoneNumber.indexOf("+1") !== -1 && this.props.phoneNumber.slice(2, this.props.phoneNumber.length)) || this.props.phoneNumber;
      phone && this.setState({ mobileNumber: normalizeInput(phone), mobileReadOnly: true })
    }
    this.isValidForm();
  }

  handleValueChange = (event: any) => {
    let { value,name } = event.target;

    if((name === 'USDOTNO' || name === 'corporateZipCode') && value.length >= 4){
      this.validateFeilds(event);
    }
    // Regarding Defect DE15972
    if(!this.props?.isMFA && name === 'mobileNumber' && value.length >= 12) {
      this.mobileValidation(value);
    }
    if(this.props?.isMFA && this.props?.phoneNumber >= 12) {
      this.mobileValidationforMFA(this.props?.phoneNumber);
    }
    const isEmptyString = (name && name !=="addressDTOs") && (value && value.trim().length===0) || false;
    if(isEmptyString) { return; }
    if (mobileNumberCheck(event)) {
      this.setState({ mobileNumber: normalizeInput(value) });
      return true;
    }
    if (
      !textpattern.test(event.target.value) &&
      (event.target.name === RegisterForm.firstName || event.target.name === RegisterForm.lastName)
    ) {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]*/g, '');
    }
    if (event.target.name === RegisterForm.slectedNo) {
      this.setState(this.state.usDotError ? {
        placeHolderText: getCarrierUSDotNoPlaceHolder(event),
        usDotError: event.target.value === carrierUsDotNo ? REGISTER_ERROR_MESSAGE.usDotError : REGISTER_ERROR_MESSAGE.mcError
      } : {
          placeHolderText: event.target.value === carrierUsDotNo ? REGISTER_PLACEHOLDER.usDot : REGISTER_PLACEHOLDER.mc,
        });
    }
    this.setState({
      [event.target.name]: value
    }, () => {
      this.isValidForm()
    });
  };
  mobileValidationforMFA = (mobilenumber: string, countryCode?:string,code?:string) => {
    this.props.setMobileValidateError(false);
    this.setState({ mobileValError: 1, allowToSave: true})
    this.isValidForm();
    this.setState({editMobileNumber:false})
  }
  
  mobileValidation = (mobilenumber: string, countryCode?:string,code?:string) => {
     let mobileNumberWithCountryCode: string = mobilenumber && (countryCode?countryCode.concat(mobilenumber):this.state.countryCode.concat(mobilenumber));
     const valMobileNumberSchema = new validateMobileNumberSchema({ phoneNumber: validatePhoneNumberFormat(mobileNumberWithCountryCode), countryCode:code?code:this.state.payloadCountryCode});
      this.props.dispatch(validateMobileNumber({
        param: valMobileNumberSchema.validateMobileNumber(), callback: (data: any) => {  
            if (data.msg === "success") {
              this.props.setMobileValidateError(false);
              this.setState({ mobileValError: 1, allowToSave: true})
              this.isValidForm();
              this.setState({editMobileNumber:false})
            }  else if(data.msg === "err") {
              this.props.setMobileValidateError(true);
              this.setState({ mobileNumberError: USER_FORM_ERRORS.mobileNumber, mobileValError: 0,allowToSave: false });
              this.isValidForm();
          } 
        }
      }))
  }

  onFocus = (event: any, countryCde: string,countryName: string) => {
    const {name }= event.target;
    this.setState({countryCode :countryCde,payloadCountryCode:countryName});
    if(name === 'mobileNumber') {
      this.props.setMobileValidateError(false);
      this.isValidForm();
    }
  }
  isValidForm = () => {
  if (
      this.state.isRoleSelected &&
      this.state.firstName.length > 0 &&
      this.state.lastName.length > 0 &&
      this.state.companyName.length > 0 &&
      (this.props.isMFA ||
       (this.state.mobileNumber.length === 12 &&
        this.state.mobileValError === 1)) &&
      this.state.corporateZipCode.length > 0 &&
      this.state.USDOTNO.length > 0 &&
      (!!this.state.isDriverSelected
        ? this.state.tractorNumber.length > 0
        : true) &&
      (this.state.usDotError !== null &&
      this.state.usDotError !== REGISTER_ERROR_MESSAGE.usDotError &&
      this.state.usDotError !== REGISTER_ERROR_MESSAGE.mcError)
    ) {
      this.setState({
        allowToSave: true,
        mobileValError: 1,
        mobileNumberError: ''
      });
    } else {
      this.setState({ allowToSave: false });
    }
  }

  optionClicked = (selectedRole: any) => {
    const roles = this.state.role;
    roles.forEach((role: any) => {
      if (role.label === selectedRole.label) role.selected = !role.selected;
    });
    const selectedValues: any = [];
    this.state.role.forEach((role: any) => {
      if (role.selected === true) selectedValues.push(role.value);
    });
    const selected = getSelectedRoles(this.state.role);
    this.setState({ isRoleSelected: (selected.length > 0) ? true : false });
    const event = { target: { name: 'role', value: selected } };
    this.validateFeilds(event);
    const isDriverSelected = this.state.role.find(
      (role: any) => role.selected && role.label === 'Driver'
    );
    if (!isDriverSelected) this.setState({ tractorNumber: "" });
    this.setState({ isDriverSelected: !!isDriverSelected }, () => this.isValidForm());
  };

  validateFeilds = (event: any) => {
    const { name, value } = event.target;
    const mobileErrorMessage = IONICWrapper.details.keys
       && IONICWrapper.details.keys.configuration.validPhNoErrorMessage;
    switch (name) {
      // Regarding Defect DE15972
      case RegisterForm.mobileNumber:
        if (!this.props.isMFA) {
          const currentValue = value.replace(/[^+0-9+]*/g, '');
          if (handlePhoneNumber(currentValue)) {
        this.setState({ mobileNumberError: '', mobileNumber: value });
          } else {
        this.setState({
          mobileNumberError: mobileErrorMessage
        });
          }
        }
        break;
      case RegisterForm.corporateZipCode:
        this.setState({
          zipcodeEror: (textpattern.test(value) && value.length <= 10 && value.length > 0) ? '' :
            REGISTER_ERROR_MESSAGE.zipcodeEror
        });
        break;
      case 'USDOTNO':
        if(value === "") {
          this.setState({usDotError: null})
          break;
        }
        this.setState({
          usDotError: (numericPattern.test(value) && value.length >= 6 && value.length <= 8) ? '' :
            this.state.slectedNo === carrierUsDotNo
              ? REGISTER_ERROR_MESSAGE.usDotError
              : REGISTER_ERROR_MESSAGE.mcError
        });
        break;
      case 'role':
        this.setState(roleError(value));
        break;
      case RegisterForm.firstName:
        this.setState(firstNameError(value));
        break;
      case RegisterForm.lastName:
        this.setState(lastNameError(value));
        break;
      case RegisterForm.companyName:
        this.setState(companyNameError(value));
        break;
      case RegisterForm.tractorNumber:
        const isString = ((typeof value === "string") && (value && value.trim().length > 0)) || false;
        this.setState({
          tractorNumberError:
            !isString ? REGISTER_ERROR_MESSAGE.tractorNumberError : ""
        });
        break;
    }
  };

  onChangeCountryCode = (countryCode: string) => {
    this.setState({countryCode : countryCode});
  }
  onChangePayloadCountryCode = (countryName:string) => {
    this.setState({payloadCountryCode: countryName});
  }
  render() {
    return (
      <IonPage className="registration-container">
        <NetworkErrorToaster />
        {isPlatform('mobile') ? (
          <RegistrationFormMobile
            {...this.props}
            {...this.state}
            optionClicked={this.optionClicked}
            handleValueChange={this.handleValueChange}
            validateFeilds={this.validateFeilds}
            submitForm={() => this.props.submitForm({ ...this.state })}
            mobileValidation={this.props.isMFA && this.mobileValidationforMFA}
            onChangeCountryCode={this.onChangeCountryCode}
            onChangePayloadCountryCode={this.onChangePayloadCountryCode}
            isMFA={this.props.isMFA}
             />
        ) : (
            <RegistrationFormDesktop
              {...this.props}
              {...this.state}
              optionClicked={this.optionClicked}
              handleValueChange={this.handleValueChange}
              validateFeilds={this.validateFeilds}
              submitForm={() => this.props.submitForm({ ...this.state })}
              mobileValidation={this.props.isMFA && this.mobileValidationforMFA}
              isMFA={this.props.isMFA}
              onFocus={!this.props.isMFA && this.onFocus}
               />
          )}
      </IonPage>
    );
  }
}
export default RegisterComponent;
function companyNameError(value: any): any {
  const isString = (value && value.trim().length > 0) || false;
  return { companyNameError: isString ? '' : REGISTER_ERROR_MESSAGE.companyNameError };
}

function lastNameError(value: any): any {
  const isString = (value && value.trim().length > 0) || false;
  return { lastNameError: isString ? '' : REGISTER_ERROR_MESSAGE.lastNameError };
}

function firstNameError(value: any): any {
  const isString = (value && value.trim().length > 0) || false;
  return { firstNameError: isString ? '' : REGISTER_ERROR_MESSAGE.firstNameError };
}

function roleError(value: any): any {
  return { roleError: value.length > 0 ? '' : REGISTER_ERROR_MESSAGE.roleError };
}

function getCarrierUSDotNoPlaceHolder(event: any) {
  return event.target.value === carrierUsDotNo ? REGISTER_PLACEHOLDER.usDot : REGISTER_PLACEHOLDER.mc;
}

function mobileNumberCheck(event: any) {
  return event.target.name === RegisterForm.mobileNumber;
}

